import Axios from "axios";
import React, { useState } from "react";
import { FaRegEdit, FaCheck } from "react-icons/fa";

const ParticipantScore = ({ participants, score, parameters, competition }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedScore, setEditedScore] = useState(score);
  const [disabled, setDisabled] = useState(false);

  const editScore = () => {
    setIsEditing(true);
    let inputElements = document.getElementsByClassName(score.participant);
    Array.prototype.forEach.call(inputElements, (element) => {
      element.readOnly = false;
      element.classList.remove("form-control-plaintext");
      element.type = "number";
    });
  };

  const saveEditedScore = () => {
    if (
      parameters.find(
        (element) =>
          element.parameterWeightage < editedScore[element.parameterName]
      )
    ) {
      window.alert("The entered score cannot be greater than the weightage!");
    } else {
      setDisabled(true);
      Axios.post(
        "https://ashish.moodi.org/multicity/edit_mul_scores",
        {
          score: editedScore,
          competition: competition,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setEditedScore(res.data.score);
            let inputElements = document.getElementsByClassName(
              score.participant
            );
            Array.prototype.forEach.call(inputElements, (element) => {
              element.readOnly = true;
              element.classList.add("form-control-plaintext");
              element.type = "text";
            });
            setDisabled(false);
            setIsEditing(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const onScoreChange = (e) => {
    setEditedScore({
      ...editedScore,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <tr className="border border-warning">
      <td className="px-4 text-center">
        Slot -{" "}
        {participants.find((element) => element.mcpId === score.participant)
          ? participants.find((element) => element.mcpId === score.participant)
              .slotNumber
          : 0}
      </td>
      {parameters.map((parameter) => {
        return (
          <td
            className="px-4 text-center"
            key={`akbhdjsakd${parameter.parameterName}`}
          >
            <input
              className={`form-control-plaintext ${score.participant}`}
              type="text"
              onChange={onScoreChange}
              name={parameter.parameterName}
              id={parameter.parameterName}
              value={editedScore[parameter.parameterName]}
              readOnly
              max={parameter.parameterWeightage}
            />
          </td>
        );
      })}
      <td className="px-4 text-center">{editedScore.totalScore}</td>
      <td>
        {isEditing ? (
          disabled ? (
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          ) : (
            <FaCheck style={{ cursor: "pointer" }} onClick={saveEditedScore} />
          )
        ) : (
          <FaRegEdit style={{ cursor: "pointer" }} onClick={editScore} />
        )}
      </td>
    </tr>
  );
};

export default ParticipantScore;
